/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_10 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElButton as __unplugin_components_9 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElRow as __unplugin_components_8 } from 'element-plus/es';import 'element-plus/es/components/row/style/css';
import { ElSelect as __unplugin_components_7 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import { ElCol as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/col/style/css';
import { ElSwitch as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/switch/style/css';
import { ElRadioGroup as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/radio-group/style/css';
import { ElRadio as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/radio/style/css';
import { ElFormItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElInput as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, isRef as _isRef } from "vue";
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("span", null, "按钮配置"), /*#__PURE__*/_createTextVNode(), /*#__PURE__*/_createElementVNode("span", {
  class: "sub-title"
}, "若未上传自定义图片则默认使用预设icon")], -1);
const _hoisted_3 = {
  class: "dialog-footer"
};
import { ElForm } from 'element-plus';
import { apiUsdkAddEditH5 } from '@/api/usdk';
import UUpload from '@ultra/share/components/UUpload/index.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'addEditModal',
  emits: ['refresh'],
  setup(__props, {
    expose,
    emit
  }) {
    const dialogVisible = ref(false);
    const gid = ref();
    const formData = ref({
      webId: '',
      webUrl: '',
      orientation: 0,
      name: '',
      fn: []
    });
    const fnTypes = ref([{
      label: '返回',
      value: 0
    }, {
      label: '前进',
      value: 1
    }, {
      label: '后退',
      value: 2
    }, {
      label: '刷新',
      value: 3
    }, {
      label: '分享',
      value: 4
    }]);
    const defaultIcon = ref(['https://s-static.yingxiong.com/file/1634195005545_79618838.png', 'https://s-static.yingxiong.com/file/1634194968419_36062535.png', 'https://s-static.yingxiong.com/file/1634194940510_5357056.png', 'https://s-static.yingxiong.com/file/1634195055944_30141356.png', 'https://s-static.yingxiong.com/file/1634195079045_49674786.png']);
    const cornerOptions = ref([]);
    const position = ref(['', '左上', '右上', '左下', '右下']);
    const type = ref('add');
    const ruleForm = ref();
    const handleFnType = item => {
      item.icon = defaultIcon.value[item.fnType];
    };
    const handleClose = () => {
      var _ruleForm$value;
      dialogVisible.value = false;
      (_ruleForm$value = ruleForm.value) === null || _ruleForm$value === void 0 ? void 0 : _ruleForm$value.resetFields();
      formData.value = {
        webId: '',
        webUrl: '',
        name: '',
        orientation: 0,
        fn: []
      };
    };
    const handleOk = () => {
      ruleForm.value.validate(async valid => {
        if (valid) {
          cornerOptions.value.forEach(item => {
            if (typeof item.icon != 'string') {
              item.icon = item.icon.length > 0 ? item.icon[0].url : defaultIcon.value[item.fnType];
            }
          });
          console.log(cornerOptions);
          formData.value.fn = cornerOptions.value;
          const res = await apiUsdkAddEditH5({
            ...formData.value,
            gid: gid.value
          });
          if (res.code === 0) {
            emit('refresh');
            handleClose();
          }
        }
      });
    };
    const showModal = payload => {
      dialogVisible.value = true;
      type.value = payload.type;
      gid.value = payload.gid;
      console.log('payload--');
      console.log(payload);
      cornerOptions.value = [];
      [1, 2, 4, 3].forEach(i => {
        cornerOptions.value.push({
          position: i,
          fnType: 0,
          icon: defaultIcon.value[0],
          status: 0
        });
      });
      if (payload.type === 'edit') {
        formData.value = payload.data;
        if (payload.data.fn && payload.data.fn.length > 0) {
          cornerOptions.value = payload.data.fn;
        }
      }
    };
    expose({
      showModal
    });
    return (_ctx, _cache) => {
      const _component_el_input = __unplugin_components_0;
      const _component_el_form_item = __unplugin_components_1;
      const _component_el_radio = __unplugin_components_2;
      const _component_el_radio_group = __unplugin_components_3;
      const _component_el_switch = __unplugin_components_4;
      const _component_el_col = __unplugin_components_5;
      const _component_el_option = __unplugin_components_6;
      const _component_el_select = __unplugin_components_7;
      const _component_el_row = __unplugin_components_8;
      const _component_el_button = __unplugin_components_9;
      const _component_el_dialog = __unplugin_components_10;
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        "before-close": () => handleClose(),
        title: `${_unref(type) === 'add' ? '添加' : '编辑'}H5页面`,
        width: "600px"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_3, [_createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = $event => handleClose())
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[5] || (_cache[5] = $event => handleOk())
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_unref(ElForm), {
          ref_key: "ruleForm",
          ref: ruleForm,
          model: _unref(formData),
          "label-width": "95px",
          labelAlign: "right"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            rules: {
              required: true,
              message: '请输入页面ID',
              trigger: 'blur'
            },
            label: "页面ID",
            prop: "webId"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(formData).webId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(formData).webId = $event),
              disabled: _unref(type) === 'edit'
            }, null, 8, ["modelValue", "disabled"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            rules: {
              required: true,
              message: '请输入功能名称',
              trigger: 'blur'
            },
            label: "功能名称",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(formData).name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(formData).name = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            rules: {
              required: true,
              message: '请输入跳转地址',
              trigger: 'blur'
            },
            label: "跳转地址",
            prop: "webUrl"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(formData).webUrl,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(formData).webUrl = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            rules: {
              required: true,
              message: '请选择屏幕方向',
              trigger: 'change'
            },
            label: "屏幕方向",
            prop: "orientation"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: _unref(formData).orientation,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(formData).orientation = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: 0
              }, {
                default: _withCtx(() => [_createTextVNode("横屏")]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: 1
              }, {
                default: _withCtx(() => [_createTextVNode("竖屏")]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"]), _hoisted_2, _createVNode(_component_el_row, {
          class: "btn-group"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cornerOptions), (item, index) => {
            return _openBlock(), _createBlock(_component_el_col, {
              key: index,
              offset: index % 2 == 1 ? 1 : 0,
              span: 11,
              class: "item"
            }, {
              default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_unref(position)[item.position]) + "按钮: ", 1), _createVNode(_component_el_switch, {
                modelValue: item.status,
                "onUpdate:modelValue": $event => item.status = $event,
                "active-value": 1,
                "inactive-value": 0
              }, null, 8, ["modelValue", "onUpdate:modelValue"]), _createVNode(_component_el_row, {
                align: "middle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_col, {
                  span: 6
                }, {
                  default: _withCtx(() => [_createTextVNode("功能:")]),
                  _: 1
                }), _createVNode(_component_el_col, {
                  span: 18
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_select, {
                    modelValue: item.fnType,
                    "onUpdate:modelValue": $event => item.fnType = $event,
                    onChange: $event => handleFnType(item)
                  }, {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fnTypes), f => {
                      return _openBlock(), _createBlock(_component_el_option, {
                        key: f.value,
                        label: f.label,
                        value: f.value
                      }, {
                        default: _withCtx(() => [_createTextVNode(_toDisplayString(f.label), 1)]),
                        _: 2
                      }, 1032, ["label", "value"]);
                    }), 128))]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])]),
                  _: 2
                }, 1024)]),
                _: 2
              }, 1024), _createVNode(_component_el_row, {
                style: {
                  "margin-top": "10px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_col, {
                  span: 6
                }, {
                  default: _withCtx(() => [_createTextVNode("icon:")]),
                  _: 1
                }), _createVNode(_component_el_col, {
                  span: 18
                }, {
                  default: _withCtx(() => [_createVNode(UUpload, {
                    modelValue: item.icon,
                    "onUpdate:modelValue": $event => item.icon = $event,
                    limit: 1,
                    accept: ".png,.jpg",
                    listType: "picture-card"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
                  _: 2
                }, 1024)]),
                _: 2
              }, 1024)]),
              _: 2
            }, 1032, ["offset"]);
          }), 128))]),
          _: 1
        })])]),
        _: 1
      }, 8, ["modelValue", "before-close", "title"]);
    };
  }
});